import React, { useMemo } from 'react'
import {
  TextField,
  Box,
  Typography
} from '@mui/material'
import PropTypes from 'prop-types'
import styles from './TemplateVariableInput.module.scss'

const TemplateVariableInput = ({
  label,
  value,
  onChange,
  multiline = false,
  rows = 1,
  helperText,
  required = false,
  ...textFieldProps
}) => {
  const validVariables = useMemo(() => [
    '{campaign_name}',
    '{usage_percent}',
    '{plan_minutes}',
    '{current_month_minutes}'
  ], [])

  const foundVariables = useMemo(() => {
    if (!value) return []
    return validVariables.filter(variable =>
      value.includes(variable)
    )
  }, [value, validVariables])

  return (
    <Box>
      <TextField
        label={label}
        value={value || ''}
        onChange={onChange}
        multiline={multiline}
        rows={multiline ? rows : undefined}
        fullWidth
        required={required}
        helperText={helperText}
        className={styles.textField}
        InputProps={{
          style: {
            backgroundColor: foundVariables.length > 0 ? 'rgba(25, 118, 210, 0.02)' : 'transparent'
          }
        }}
        {...textFieldProps}
      />

      {value && (
        <Box className={styles.statusBox}>
          {foundVariables.length > 0 ? (
            <Box>
              <Typography variant="body2" className={styles.validVariables}>
                ✓ {foundVariables.length} variable{foundVariables.length !== 1 ? 's' : ''} detected:
              </Typography>
              <Box mt={0.5}>
                {foundVariables.map(variable => (
                  <span key={variable} className={styles.variableChip}>
                    {variable}
                  </span>
                ))}
              </Box>
            </Box>
          ) : (
            <Typography variant="body2" className={styles.noVariables}>
              No template variables found. Available: {validVariables.join(', ')}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  )
}

TemplateVariableInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  helperText: PropTypes.string,
  required: PropTypes.bool
}

export default TemplateVariableInput
